<template>
    <div>
        <div class="subtitle_of_projects">
            <el-row>
                <el-col :span="2"><div class="grid-content"></div></el-col>
                <el-col :span="20" class="decoration_line">
                    <div class="subtitle_text">
                    HUMAN-COMPUTER INTERACTION
                    </div>
                </el-col>

                <el-col :span="2"><div class="grid-content"></div></el-col>
            </el-row>
        </div>
        <div class="content">
            <el-row>
                <el-col :span="2"><div class="grid-content"></div></el-col>
                <el-col :span="6">
                <div class="grid-content-img">
                    <a class="info" href="#/project15">
                        <div class="image15">
                        </div>
                        <p class="info">K9-R Interaction Intent Prediction</p>
                    </a>
                </div>
            </el-col>
                <el-col :span="1"><div class="grid-content"></div></el-col>
                <el-col :span="6">
                <div class="grid-content-img">
                    <a class="info" href="#/project12">
                        <div class="image12">
                        </div>
                        <p class="info">Prop-based virtual reality storytelling</p>
                    </a>
                </div>
            </el-col>
                <el-col :span="1"><div class="grid-content"></div></el-col>
                <el-col :span="6">
                    <div class="grid-content-img">
                        <a class="info" href="#/project1">
                            <div class="image1"></div>
                            <p>VR cultural exhibition UX model</p>
                        </a>
                    </div>
                </el-col>
                <el-col :span="2"><div class="grid-content"></div></el-col>
            </el-row>
        </div>
        <div class="content">
            <el-row>
                <el-col :span="2"><div class="grid-content"></div></el-col>
                <el-col :span="6">
                    <div class="grid-content-img">
                        <a class="info" href="#/project18">
                            <div class="image18"></div>
                            <p>ShiftGrip: VR Dynamic Passive Haptic Device</p>
                        </a>
                    </div>
                </el-col>
                <el-col :span="1"><div class="grid-content"></div></el-col>
                <el-col :span="6">
                    <div class="grid-content-img">
                        <a class="info" href="#/project19">
                            <div class="image19"></div>
                            <p>CIA: VR Contextual Immersion Attachment</p>
                        </a>
                    </div>
                </el-col>
                <el-col :span="9"><div class="grid-content"></div></el-col>
            </el-row>
        </div>
        <div class="subtitle_of_projects">
            <el-row>
                <el-col :span="2"><div class="grid-content"></div></el-col>
                <el-col :span="20" class="decoration_line">
                    <div class="subtitle_text">
                        THEORETICAL RESEARCH & REVIEWS
                    </div>
                </el-col>

                <el-col :span="2"><div class="grid-content"></div></el-col>
            </el-row>
        </div>
        <div class="content">
        <el-row>
            <el-col :span="2"><div class="grid-content"></div></el-col>
            <el-col :span="6">
                <div class="grid-content-img">
                    <a class="info" href="#/project16">
                        <div class="image16">
                        </div>
                        <p class="info">Positioning, Applications, and Value of VR in Conceptual Design</p>
                    </a>
                </div>
            </el-col>
            <el-col :span="1"><div class="grid-content"></div></el-col>
            <el-col :span="6">
                <div class="grid-content-img">
                    <a class="info" href="#/project13">
                        <div class="image13">
                        </div>
                        <p class="info">Literature review of virtual museum</p>
                    </a>
                </div>
            </el-col>
            <el-col :span="1"><div class="grid-content"></div></el-col>
            <el-col :span="6">
                <div class="grid-content-img">
                    <a class="info" href="#/project14">
                        <div class="image14"></div>
                        <p> Product Creative Design Method</p>
                    </a>
                </div>
            </el-col>
            <el-col :span="1"><div class="grid-content"></div></el-col>
            <el-col :span="2"><div class="grid-content"></div></el-col>
        </el-row>
    </div>
        <div class="subtitle_of_projects">
            <el-row>
                <el-col :span="2"><div class="grid-content"></div></el-col>
                <el-col :span="20" class="decoration_line">
                    <div class="subtitle_text">
                        DESIGN PRACTICE
                    </div>
                </el-col>

                <el-col :span="2"><div class="grid-content"></div></el-col>
            </el-row>
        </div>
        <div class="content">
            <el-row>
            <el-col :span="2"><div class="grid-content"></div></el-col>
            <el-col :span="6">
                <div class="grid-content-img">
                    <a class="info" href="#/project17">
                        <div class="image17"> </div>
                        <p>WensoulChain - AI-Driven Cultural Creative Design Cloud Platform</p>
                    </a>
                </div>
            </el-col>
            <el-col :span="1"><div class="grid-content"></div></el-col>
            <el-col :span="6">
                <div class="grid-content-img">
                    <a class="info" href="#/project6">
                        <div class="image6">
                        </div>
                        <p class="info">AShareChain - A-Share Industry Chain Knowledge Graph Visualization Project</p>
                    </a>
                </div>
            </el-col>

            <el-col :span="1"><div class="grid-content"></div></el-col>
                <el-col :span="6">
                    <div class="grid-content-img">
                        <a class="info" href="#/project2">
                            <div class="image2"></div>
                            <p class="info">VR digital twin</p>
                        </a>
                    </div>
                </el-col>
            <el-col :span="2"><div class="grid-content"></div></el-col>
        </el-row>
        </div>
        <div class="content">
            <el-row>
                <el-col :span="2"><div class="grid-content"></div></el-col>
                <el-col :span="6">
                    <div class="grid-content-img">
                        <a class="info" href="#/project3">
                            <div class="image3">
                            </div>
                            <p class="info">
                                AR-assisted routing and assembly system</p>
                        </a>
                    </div>
                </el-col>
                <el-col :span="1"><div class="grid-content"></div></el-col>
                <el-col :span="6">
                    <div class="grid-content-img">
                        <a class="info" href="#/project9">
                            <div class="image9">
                            </div>
                            <p class="info">
                                Zhejiang University Campus Wayfinding System Design</p>
                        </a>
                    </div>
                </el-col>
                <el-col :span="1"><div class="grid-content"></div></el-col>
                <el-col :span="6">
                    <div class="grid-content-img">
                        <a class="info" href="#/project4">
                            <div class="image4"> </div>
                            <p>V-ray rendering: SSS + PBR material</p>
                        </a>
                    </div>
                </el-col>
                <el-col :span="2"><div class="grid-content"></div></el-col>
            </el-row>
        </div>
        <div class="content">
            <el-row>
                <el-col :span="2"><div class="grid-content"></div></el-col>
                <el-col :span="6">
                    <div class="grid-content-img">
                        <a class="info" href="#/project8">
                            <div class="image8">
                            </div>
                            <p class="info">Honeyjar</p>
                        </a>
                    </div>
                </el-col>

                <el-col :span="1"><div class="grid-content"></div></el-col>
                <el-col :span="6">
                    <div class="grid-content-img">
                        <a class="info" href="#/project10">
                            <div class="image10"> </div>
                            <p>Visual identity and IP design</p>
                        </a>
                    </div>
                </el-col>
                <el-col :span="1"><div class="grid-content"></div></el-col>
                <el-col :span="6">
                    <div class="grid-content-img">
                        <a class="info" href="#/project7">
                            <div class="image7"> </div>
                            <p>Product creativity design tool (WebApp)</p>
                        </a>
                    </div>
                </el-col>
                <el-col :span="2"><div class="grid-content"></div></el-col>
            </el-row>
        </div>
        <div class="content">
            <el-row>
                <el-col :span="2"><div class="grid-content"></div></el-col>
                <el-col :span="6">
                    <div class="grid-content-img">
                        <a class="info" href="#/project5">
                            <div class="image5">
                            </div>
                            <p class="info">3Dsmax plugin development for faster rendering and modeling work flow</p>
                        </a>
                    </div>
                </el-col>
                <el-col :span="16"><div class="grid-content"></div></el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Project",

    }
</script>

<style scoped>
    .grid-content-img{

    }
    .decoration_line{
        border-bottom: 1px solid black ;

    }
    .subtitle_of_projects{

        margin-top: 100px;
        margin-bottom: -70px;
    }
    .subtitle_text{
        font-weight: 200;
    }
    .image1{
        width: 25vw;
        height: 25vw;
        background-image: url("../assets/project1_7.png.webp");
        background-position: center;
        background-size: cover;
    }
    .image2{
        width: 25vw;
        height: 25vw;
        background-image: url("../assets/project2_1.png.webp");
        background-position: center;
        background-size: cover;
    }
    .image3{
        width: 25vw;
        height: 25vw;
        background-image: url("../assets/project3_7.png.webp");
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
    }
    .image4{
        width: 25vw;
        height: 25vw;
        background-image: url("../assets/bunny-pbr2.jpg.webp");
        background-position: center;
        background-size: cover;
    }
    .image5{
        width: 25vw;
        height: 25vw;
        background-image: url("../assets/3dmax.png.webp");
        background-position: left;
        background-size: cover;
    }
    .image6{
        width: 25vw;
        height: 25vw;
        background-image: url("../assets/project6_3.png.webp");
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
    }
    .image7{
        width: 25vw;
        height: 25vw;
        background-image: url("../assets/cc.jpg.webp");
        background-position: left;
        background-size: cover;
    }
    .image8{
        width: 25vw;
        height: 25vw;
        background-image: url("../assets/poster2.jpg.webp");
        background-position: center;
        background-size: cover;
    }
    .image9{
        width: 25vw;
        height: 25vw;
        background-image: url("../assets/project9_14.png.webp");
        background-position: top;
        background-size: cover;
    }
    .image10{
        width: 25vw;
        height: 25vw;
        background-image: url("../assets/ip_homepage.jpg.webp");
        background-position: center;
        background-size: cover;
    }
    .image12{
        width: 25vw;
        height: 25vw;
        background-image: url("../assets/project12_8.png.webp");
        background-position: center;
        background-size: cover;
    }
    .image13{
        width: 25vw;
        height: 25vw;
        background-image: url("../assets/project13_1.jpg.webp");
        background-position: center;
        background-size: cover;
    }
    .image14{
        width: 25vw;
        height: 25vw;
        background-image: url("../assets/project14_1.jpg.webp");
        background-position: center;
        background-size: cover;
    }
    .image15{
        width: 25vw;
        height: 25vw;
        background-image: url("../assets/project15_1.jpg");
        background-position: center;
        background-size: cover;
    }
    .image16{
        width: 25vw;
        height: 25vw;
        background-image: url("../assets/project16_1.jpg.webp");
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
    }
    .image17{
        width: 25vw;
        height: 25vw;
        background-image: url("../assets/project17_3.png.webp");
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
    }
    .image18{
        width: 25vw;
        height: 25vw;
        background-image: url("../assets/project18_7.png.webp");
        background-position: center;
        background-size: cover;
    }
    .image19{
        width: 25vw;
        height: 25vw;
        background-image: url("../assets/project19_1.png.webp");
        background-position: center;
        background-size: cover;
    }
    h1{
        font-size:30px;
        font-weight: 100;
        letter-spacing:6px;
    }
    .grid-content {
        min-height: 36px;
        border:none;

    }
    .content{
        margin-top:100px;
        margin-bottom: -40px;
    }

    .grid-content-img{
        overflow: hidden;
    }
    .grid-content-img [class^="image"]{
        transition: transform 0.42s ease;
        transform-origin: center center;
        will-change: transform;
    }
    .grid-content-img:hover [class^="image"]{
        transform: scale(1.035);
    }
    .info{
        font-size: 15px;
        color: #666;
        font-weight: 100;
        text-align: center;
        text-decoration: none;
        letter-spacing: 1px;
    }
</style>